<template>
  <div>
    <el-card>
      <div style="float: right">
        <yearcomponent @change="handler_year" />

        <el-select
          v-model="valueCompanys"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in companys"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionProducto"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionProductoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="DimensionDepartamento"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in DimensionDepartamentoOptions"
            :key="item.Code"
            :label="item.Name"
            :value="item.Code"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="valueMoney"
          v-bind="$attrs"
          size="mini"
          placeholder="Select"
          v-loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div style="margin-top: 50px">
        <rabbey-table3
          :columns="months"
          :data="dataReStatus"
          :loading="loading"
          :row-class-name="changeRowClassName"
          :maxheight="1000"
          :paginationApi="{
            currentPage: 1,
            pageSize: 200
          }"
          :pageSizes="[200, 400, 600]"
          default-expand-all
        ></rabbey-table3>
      </div>
    </el-card>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import Months from "@/views/modules/Status/columns/MonthColumns";
import yearcomponent from "@/components/Global_System/YearsComponent";

export default {
  name: "ResultsByMonth",
  components: { yearcomponent },
  data() {
    return {
      months: Months,
      loading: false,
      options: [
        {
          value: "RD",
          label: "RD$"
        },
        {
          value: "US",
          label: "US$"
        }
      ],
      companys: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 7,
          label: "NUPSHOP"
        },
        {
          value: "Consolidado",
          label: "Consolidado"
        }
      ],
      dataReStatus: [],
      year: 2023,
      valueCompanys: 4,
      valueMoney: "RD",
      DimensionProductoOptions: [],
      DimensionProducto: "*",
      DimensionDepartamentoOptions: [],
      DimensionDepartamento: "*"
    };
  },
  mounted() {
    this.getDimension();
    this.GetDataResultStatus();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetDataResultStatus();
    },
    getDimension() {
      this.loading = true;

      this.$http
        .get(`/api/resultsStatus/GetDimesionProducto`)
        .then((resp) => {
          this.loading = false;
          this.DimensionProductoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));

      this.$http
        .get("/api/resultsStatus/GetDimesionDepartamento")
        .then((resp) => {
          this.loading = false;
          this.DimensionDepartamentoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    GetDataResultStatus() {
      this.loading = true;

      var params = {
        option: this.valueCompanys,
        year: this.year,
        divisa: this.valueMoney,
        dim_pro: this.DimensionProducto,
        dim_dep: this.DimensionDepartamento
      };
      this.$http
        .get(`/api/resultsStatus/GetDataResultStatus`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;
          this.dataReStatus = resp.data;
          // this.dataReStatus = resp.data.filter(
          //   (request) => request.nombre != ""
          // );
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    changeRowClassName({ row /*, rowIndex*/ }) {
      //console.log("row: ", row, "\nrowIndex: ", rowIndex)

      switch (row.cuenta) {
        case "79999995": {
          //console.log("lastrow")
          return "fixedRow2";
        }
        case "79999997": {
          return "fixedRow1";
        }
        case "79999999": {
          return "fixedRow";
        }
        default: {
          break;
        }
      }
    }
  },
  watch: {
    DimensionProducto() {
      this.GetDataResultStatus();
    },
    DimensionDepartamento() {
      this.GetDataResultStatus();
    },
    valueCompanys() {
      this.GetDataResultStatus();
    },
    year() {
      this.GetDataResultStatus();
    },
    valueMoney() {
      this.GetDataResultStatus();
    }
  }
};
</script>

<style scoped></style>
